<template lang="pug">
#modalCreateGroup.modal(ref="modal")
  .modal-dialog(:class='{"modal-lg": step == "public"}')
    .modal-content
      .modal-header
        button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
        h4.modal-title 
          template(v-if='step == "general"') {{$t("groups.createModal.title.general")}}
          template(v-if='step == "public"') {{$t("groups.createModal.title.page")}}
      .modal-body
        div(v-show='savingState == null')
          vue-object-img(:object="inCreationGroup", v-if='step == "general"')
          group-editor(:group="inCreationGroup", :part="step", ref="generalPart", @success="success", @error="error", :complete.sync="mustHaveIsComplete")

        .bigIconMessage(v-if='savingState == "saving"')
          i.fa.fa-refresh.fa-spin.grey
          |  {{$t("globals.sending")}}
        .bigIconMessage(v-if='savingState == "saved"')
          i.fa.fa-check.green
          |  {{$t("globals.created")}}

        .bigIconMessage(v-if='savingState == "error"')
          i.fa.fa-remove.red
          |  {{$t("globals.error")}}

      .modal-footer(v-if='savingState == null')
        button.btn.btn-default.pull-left(type="button", @click='prev()')
          template(v-if='step == "general"') {{$t('globals.cancel')}}
          template(v-if='step == "page"') {{$t('globals.previous')}}
        //- button.btn.btn-warning.pull-left(type="button") Sauver comme brouillon
        button.btn.btn-primary(type="button", :class='{disabled: !mustHaveIsComplete}', @click='next()')
          //- template(v-if='step == "general"') {{$t('globals.next')}}
          //- template(v-if='step == "page"') {{$t('globals.create')}}
          | {{$t('globals.create')}}
</template>
<script>
// import api from '@/utils/api'
import $ from 'jquery'

import modalsBus from '@/components/shared/ModalsBus'
import VueObjectImg from '@/components/shared/VueObjectImg'

import GroupEditor from './GroupEditor'

// import { Picker } from 'emoji-mart-vue'

export default {
  data () {
    return {
      inCreationGroup: null,
      step: 'general',
      savingState: null,
      publicUrl: '',
      mustHaveIsComplete: false
    }
  },
  components: {
    VueObjectImg,
    GroupEditor
    // Picker
  },
  mounted () {
    modalsBus.onOpen((arg, object) => {
      if (arg === modalsBus.modals.CREATE_GROUP) {
        this.beforeCreate()
        this.show(object)
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
    $(this.$refs.modal).on('shown.bs.modal', () => {
      this.$refs.generalPart.focusOnInput()
    })
  },
  methods: {
    show (params = {}) {
      this.$nextTick(() => {
        if (params.type) {
          this.$refs.generalPart.setType(params.type)
        }
        $(this.$refs.modal).modal('show')
      })
    },
    closeModal () {
      return $(this.$refs.modal).modal('hide')
    },
    createGroup () {
      $(this.$refs.modal).modal('show')
    },
    success (group) {
      this.savingState = 'saved'
      setTimeout(() => {
        $(this.$refs.modal).modal('hide')
        setTimeout(() => {
          this.beforeCreate()
        }, 1000)
        this.$store.dispatch('groops/select', [group])
        this.$router.push({name: 'Members'})
        modalsBus.open(modalsBus.modals.CREATE_MEMBERS)
        // vueModel.groups.push(data.group)
        // vm.selectGroup(data.group)
        // vm.openCreateMembers()
      }, 1000)
    },
    error () {
      this.savingState = 'error'
      setTimeout(() => {
        this.savingState = null
        // vueModel.groups.push(data.group)
        // vm.selectGroup(data.group)
        // vm.openCreateMembers()
      }, 1000)
    },
    beforeCreate () {
      this.inCreationGroup = {
        kind: 'group',
        id: null,
        name: '',
        type: -1,
        isPublic: true
      }
      this.savingState = null
      this.step = 'general'
    },
    // addEmoji (emoji) {
    //   this.name += emoji.native
    // },
    next () {
      if (!this.mustHaveIsComplete) {
        return
      }
      if (this.step === 'general') {
        // this.step = 'page'
      // } else if (this.step === 'page') {
        this.savingState = 'saving'
        this.$refs.generalPart.save()
      }
    },

    prev () {
      if (this.step === 'general') {
        $(this.$refs.modal).modal('hide')
        this.beforeCreate()
      } else if (this.step === 'page') {
        this.step = 'general'
      }
    }
  }
}
</script>
<style lang="sass">
#modalCreateGroup
  .profileImage
    height: 60px
    line-height: 60px
    width: 60px
    margin-left: 50%
    transform: translateX(-50%)
    margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// NewGroup.vue?687f5b70